









































import Vue, { PropType } from 'vue'
import { IRoom } from '@/models/IRoom'

export default Vue.extend({
  name: 'RoomSimpleCard',
  props: {
    room: {
      type: Object as PropType<IRoom>,
      required: true
    }
  },
  methods: {
    roomFreeSpace(room: IRoom) {
      return room.size - room.students.length
    }
  }
})
